import {SharedQuestion} from "./SharedQuestion";

export class RateSharedQuestion extends SharedQuestion {

    protected value:IValue;

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        return this.isEmpty();
    }

    isEmpty():boolean {
        return this.value != null;
    }

    validationMessage():string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'rating_validation_message';
    }

    getValue():IValue {
        return this.value;
    }

    setValue(value:IValue) {
        this.value = value;
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        return currentValues[0].value === value.value
    }
}